module.exports = __webpack_public_path__ + "static/media/logo.d02ba67c.svg";